import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isValidVietnamesePhoneNumber(
    control: AbstractControl
): ValidationErrors | null {
    const phoneNumberRegex = /^(\+84|0)\d{8,11}$/;
    return !control.value || phoneNumberRegex.test(control.value)
        ? null
        : { phoneNumber: true };
}
